import * as PIXI from 'pixi.js';
import * as CONST_HORIZONTAL from './table-cards-controller-horizontal.const';
import * as CONST_VERTICAL from './table-cards-controller-vertical.const';
import { Card } from '../card';
import { CardData } from '../../../../shared/models';
import { AnchorPosition } from '../const';
import { environment } from '../../../../../environments/environment';
import { GameComponent } from '../../game.component';

export class TableCardsController {

    container: PIXI.Container;
    communityCards: Card[] = [];
    r2tCardsT1: Card[] = [];
    r2tCardsT2: Card[] = [];

    private CONST;
    public gameComponent: GameComponent
    constructor(private textures, gameComponent: GameComponent, useVerticalMode: boolean) {
        this.container = new PIXI.Container();
        this.gameComponent = gameComponent;
        if (useVerticalMode) {
            this.CONST = CONST_VERTICAL;
        } else {
            this.CONST = CONST_HORIZONTAL;
        }
        this.container.position.set(
            this.CONST.tableCardsContainerPosition.x,
            this.CONST.tableCardsContainerPosition.y,
        );

        // setTimeout(() => {
        //     this.addCommunityCards([
        //         { Suit: 3, Number: 9, Name: 's9', IsRabbitHunting: undefined },
        //         { Suit: 1, Number: 7, Name: 'd7', IsRabbitHunting: undefined },
        //         { Suit: 2, Number: 2, Name: 'c2', IsRabbitHunting: undefined }
        //     ])
        // }, 2000);
    }

    private applyCommunityPerspective(card: Card, index: number, scale = this.CONST.communityCardScale) {
        const tilts = this.CONST.communityCardEdgeTilt;
        const localRatio = scale.y / scale.x;
        card.applyPerspectiveQuad(
            Math.tan(tilts[index]) * localRatio,
            Math.tan(tilts[index + 1]) * localRatio,
        );
    }

    updateRotationMode(useVerticalMode: boolean) {
        if (useVerticalMode) {
            this.CONST = CONST_VERTICAL;
        } else {
            this.CONST = CONST_HORIZONTAL;
        }
        this.container.position.set(
            this.CONST.tableCardsContainerPosition.x,
            this.CONST.tableCardsContainerPosition.y,
        );

        this.communityCards.forEach((card, index) => {
            card.container.position.set(this.CONST.communityCardPositions[index].x, this.CONST.communityCardPositions[index].y)
            card.container.scale.set(this.CONST.communityCardScale.x, this.CONST.communityCardScale.y)
            this.applyCommunityPerspective(card, index)
        })
        this.layoutR2tCards();
    }

    update(dt) {
        this.communityCards.forEach(card => {
            card.update(dt);
        });

        this.r2tCardsT1.forEach(card => {
            card.update(dt);
        });

        this.r2tCardsT2.forEach(card => {
            card.update(dt);
        });
    }

    addCommunityCards(cardsData: CardData[] = []) {

        if (cardsData.length > 5) { throw Error('Max num. of community cards is 5'); }
        cardsData.forEach((cardData, index) => {
            const card = new Card(this.textures['tableCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData);
            card.setPosition(this.CONST.communityCardPositions[index], AnchorPosition.topLeft);
            card.container.scale.set(this.CONST.communityCardScale.x, this.CONST.communityCardScale.y);
            this.applyCommunityPerspective(card, index);
            this.container.addChild(card.container);
            this.communityCards.push(card);
        });

    }

    addCommunityCard(cardData: CardData) {

        const index = this.communityCards.length;
        const card = new Card(this.textures['tableCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData);
        card.setPosition(this.CONST.communityCardPositions[index], AnchorPosition.topLeft);
        card.container.scale.set(this.CONST.communityCardScale.x, this.CONST.communityCardScale.y);
        this.applyCommunityPerspective(card, index);
        this.container.addChild(card.container);
        this.communityCards.push(card);


    }

    addCommunityCardWithIndex(cardData: CardData, index: number) {

        const card = new Card(this.textures['tableCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData);
        card.setPosition(this.CONST.communityCardPositions[index], AnchorPosition.topLeft);
        card.container.scale.set(this.CONST.communityCardScale.x, this.CONST.communityCardScale.y);
        this.applyCommunityPerspective(card, index);
        this.container.addChild(card.container);
        this.communityCards.push(card);
    }

    removeAllCards() {
        this.container.removeChildren();
        this.communityCards = [];
        this.r2tCardsT1 = [];
        this.r2tCardsT2 = [];
    }

    getCommunityCardsInShortNotation(): string {
        let shortNotation = '';
        this.communityCards.forEach(card => {
            shortNotation += card.cardData.Name + ' ';
        });
        return shortNotation.trim();
    }

    addR2tCardsT1(cardsData: CardData[] = []) {
        if (cardsData.length > 5) { throw Error('Max num. of r2t cards is 5'); }
        cardsData.forEach((cardData, index) => {
            const card = new Card(this.textures['tableCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData);
            this.container.addChild(card.container);
            this.r2tCardsT1.push(card);
        });
        this.layoutR2tCards();
    }

    addR2tCardsT2(cardsData: CardData[] = []) {
        if (cardsData.length > 5) { throw Error('Max num. of r2t cards is 5'); }
        cardsData.forEach((cardData, index) => {
            const card = new Card(this.textures['tableCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData);
            this.container.addChild(card.container);
            this.r2tCardsT2.push(card);
        });
        this.layoutR2tCards();
    }

    get hasR2tCards(): boolean {
        return this.r2tCardsT1.length > 0 || this.r2tCardsT2.length > 0;
    }

    private layoutR2tCards() {
        if (!this.hasR2tCards) { return; }

        const shared = this.communityCards.length;
        const partial = this.CONST.r2tPartialLayouts[shared];

        if (partial) {
            this.communityCards.forEach((card, slot) => {
                this.placeCard(card, slot, this.CONST.r2tSharedPositions[slot], this.CONST.r2tSharedScale);
            });
            this.r2tCardsT1.forEach((card, index) => {
                this.placeCard(card, shared + index, partial.t1[index], this.CONST.r2tPartialScale);
            });
            this.r2tCardsT2.forEach((card, index) => {
                this.placeCard(card, shared + index, partial.t2[index], this.CONST.r2tPartialScale);
            });
            return;
        }

        this.r2tCardsT1.forEach((card, index) => {
            this.placeCard(card, shared + index, this.CONST.r2tT1Positions[shared + index], this.CONST.r2tT1Scale);
        });
        this.r2tCardsT2.forEach((card, index) => {
            this.placeCard(card, shared + index, this.CONST.r2tT2Positions[shared + index], this.CONST.r2tT2Scale);
        });
    }

    private placeCard(card: Card, slot: number, position, scale) {
        card.setPosition(position, AnchorPosition.topLeft);
        card.container.scale.set(scale.x, scale.y);
        this.applyCommunityPerspective(card, slot, scale);
    }

    selectCards(cardsToSelect: any = []) {

        if (cardsToSelect.length === 0) { return }

        this.communityCards
            .forEach(card => {
                if (cardsToSelect.findIndex(selectCard => selectCard.Suit === card.cardData.Suit && selectCard.Number === card.cardData.Number) === -1) {
                    card.grayscaleCard();
                } else {
                    card.ungrayscaleCard();

                }
            })

        this.r2tCardsT1
            .forEach(card => {
                if (cardsToSelect.findIndex(selectCard => selectCard.Suit === card.cardData.Suit && selectCard.Number === card.cardData.Number) === -1) {
                    card.grayscaleCard();
                } else {
                    card.ungrayscaleCard();

                }
            })

        this.r2tCardsT2
            .forEach(card => {
                if (cardsToSelect.findIndex(selectCard => selectCard.Suit === card.cardData.Suit && selectCard.Number === card.cardData.Number) === -1) {
                    card.grayscaleCard();
                } else {
                    card.ungrayscaleCard();

                }
            })

        // ## OLD BLINKING CARDS
        // cardsToSelect.forEach(selectCard => {
        //     this.communityCards.forEach(card => {
        //         if (!card) { return; }
        //         if (card.cardData.Suit === selectCard.Suit && card.cardData.Number === selectCard.Number) {
        //             card.selectCard();
        //         }
        //     });

        //     this.r2tCardsT1.forEach(card => {
        //         if (!card) { return; }
        //         if (card.cardData.Suit === selectCard.Suit && card.cardData.Number === selectCard.Number) {
        //             card.selectCard();
        //         }
        //     });

        //     this.r2tCardsT2.forEach(card => {
        //         if (!card) { return; }
        //         if (card.cardData.Suit === selectCard.Suit && card.cardData.Number === selectCard.Number) {
        //             card.selectCard();
        //         }
        //     });
        // });
    }

    refreshCardsTexture() {
        this.communityCards.forEach(card => {
            card.refreshCard(this.textures['tableCardAtlas'], this.textures['backCard'].texture);
        });

        this.r2tCardsT1.forEach(card => {
            card.refreshCard(this.textures['tableCardAtlas'], this.textures['backCard'].texture);
        });

        this.r2tCardsT2.forEach(card => {
            card.refreshCard(this.textures['tableCardAtlas'], this.textures['backCard'].texture);
        });
    }
}
